import { render, staticRenderFns } from "./WidgetSettings.vue?vue&type=template&id=347c431a&scoped=true"
import script from "./WidgetSettings.vue?vue&type=script&lang=js"
export * from "./WidgetSettings.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettings.vue?vue&type=style&index=0&id=347c431a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c431a",
  null
  
)

export default component.exports